<template>
  <v-dialog
    eager
    ref="docentes"
    v-model="dialogDocentes"
    scrollable
    max-width="600"
  >
    <v-card>
      <v-card-title>
        <v-btn link icon absolute top right @click="dialogDocentes = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <div>
          <docente-cursado-form
            ref="form"
            :cursado_id="cursado_id"
            :id="id"
            @close="cerrar"
          >
            <template v-slot:docente_id="{ model }">
              <v-autocomplete
                label="seleccione Docente"
                v-model="model.docente_id"
                :items="users"
                item-text="searchTag"
                item-value="id"
              >
              </v-autocomplete>
            </template>
          </docente-cursado-form>
          <v-card elevation="0">
            <v-card-title v-if="cursado.espacio"
              >Docentes de {{ cursado.espacio.searchTag }}</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col align="left">
                  <v-btn @click="newItem" color="primary">Nuevo</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Buscar por campo"
                    v-model="search.tag"
                    clearable
                    @click:clear="reload"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selectedItems"
                show-select
                :loading="loading.status"
                :items="docenteCursados"
                :headers="headers"
                :server-items-length="pagination.totalCount"
                :options.sync="options"
              >
                <template v-slot:body.prepend>
                  <tr>
                    <td></td>
                    <td v-for="(filterCol, i) in headers" :key="i">
                      <v-text-field
                        v-show="filterCol.filterable"
                        hide-details
                        filled
                        :label="'Buscar por ' + filterCol.text"
                        v-model="
                          like[
                            filterCol.table ? filterCol.table : filterCol.value
                          ]
                        "
                        clearable
                        @click:clear="reload"
                      ></v-text-field>
                    </td>
                  </tr>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon color="info" class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon color="info" @click="deleteItem(item.id)">
                    mdi-delete
                  </v-icon>
                </template>

                <template v-slot:item.docente_id="{ item }">
                  {{ item.docente.nombre }} {{ item.docente.apellido }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn @click="dialogDocentes = false">Cancelar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import DocenteCursadoForm from "@/viewsNew/docente-cursado/DocenteCursadoForm";

export default {
  name: "DocenteCursadoABM",
  props: {
    cursado_id: [String, Number],
    cursado: { type: Object, default: () => {} },
  },
  components: { DocenteCursadoForm },
  data() {
    return {
      dialogDocentes: false,
      selectedItems: [],
      like: {},
      dialog: false,
      id: null,
      options: {
        joins: [],
      },
      expand: ["docente"],
      filters: {},
    };
  },
  computed: {
    ...mapState("NewUserModule", ["users"]),
    ...mapState("DocenteCursadoModule", ["docenteCursados", "pagination"]),
    ...mapState(["search", "loading", "dialogs"]),

    filterHeaders() {
      return this.headers.filter((el) => el.filterable);
    },

    headers() {
      return [
        // {text:'Id',value:'id',filterable:true},
        { text: "Docente", value: "docente_id", filterable: true },
        {
          text: "Acciones",
          value: "actions",
          filterable: false,
          nosearch: true,
        },
      ];
    },
  },
  watch: {
    dialogDocentes() {
      if (this.dialogDocentes) {
        this.reload();
      } else {
        this.$emit("close");
      }
    },
    dialog() {
      if (!this.dialog) {
        this.$refs.form.model = {};
        this.id = null;
        // this.reload();
      }
    },
    cursado() {
      // this.reload();
    },
    filters: {
      handler() {
        this.setFilters();
        this.reload();
      },
      deep: true,
    },
    like: {
      handler() {
        this.reload();
      },
      deep: true,
    },

    search: {
      handler() {
        this.setSearch();
        this.reload();
      },
      deep: true,
    },

    options: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("NewUserModule", ["getUsersPorRoles"]),
    ...mapActions("DocenteCursadoModule", [
      "getDocenteCursados",
      "deleteDocenteCursado",
    ]),
    ...mapMutations(["clearFilters", "setFilters", "setSearch"]),

    newItem() {
      this.$refs.form.model = {};
      this.$refs.form.dialog = true;
    },

    cerrar() {
      this.$refs.form.dialog = false;
      this.reload();
    },

    editItem(item) {
      this.id = item.id;
      this.$refs.form.dialog = true;
    },
    async deleteItem(id) {
      const res = await this.$dialog.confirm({
        color: "error",
        icon: "mdi-alert",
        text: "Esta seguro que desea eliminar el registro?",
        title: "Eliminar Registro",
      });
      if (res) {
        this.deleteDocenteCursado(id);
      }
    },

    async reload() {
      this.filters.cursado_id = this.cursado.id;
      this.loading.status = true;
      await this.getDocenteCursados({
        like: this.like,
        options: this.options,
        filters: this.filters,
        expand: this.expand.toString(),
        search: this.search.tag,
        headers: this.headers,
      });
      this.loading.status = false;
    },
  },
  destroyed() {
    this.clearFilters();
  },
  created() {
    this.getUsersPorRoles({ roles: ["docente"] });
  },
};
</script>

<style scoped></style>
